import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components'
//import layout from '../../layout.json'


class LayoutAvatar extends Component {
    render() {
        const { layoutUpdate, styleClass, sceneActive, layouts } = this.props;

        return layouts.map((item, index) => {
            const StyledWrapper = styled.div`width: 100%;height: 100%;${item.css}`
            return  <li className="layout_item">
            <button className={`layoutAvatar ${(sceneActive == item.id) ? `active-scene` : ``}`} onClick={layoutUpdate(item.id)}>
                <div className="layout_avtar_wrapper">
                    <StyledWrapper>
                        {
                            item.zones.map((zItem, zIndex) => <div id={zItem.id} className="zone"></div>)
                        }
                    </StyledWrapper>
                </div>
            </button>
            </li>
        })
    }
}
const mapStateToProps = state => {
    return {
        layouts: state.layout.layouts
    }
}
export default connect(mapStateToProps)(LayoutAvatar);